export default __webpack_public_path__ + "static/media/spinner.770bf73c.gif";